import { AccordionItem, AccordionItemContent, AccordionItemTrigger, AccordionRoot } from '@/components/ui/accordion'
import { Box } from '@/components/ui/box'
import { Text } from '@/components/ui/typography'
import { ICompliance } from '@/types/tasksApprovals'

import TaskItem from '../../../item/task'

const Container = ({
    arrowColor,
    tasks,
    textColor,
    title,
}: {
    arrowColor: string
    icon: string
    tasks: ICompliance[]
    textColor: string
    title: string
}) => {
    return (
        <Box py="16px" pr="12px" borderBottom="1px solid" borderColor="rgba(84, 79, 64, 0.12)">
            <AccordionRoot multiple border="0" margin="0" p="0">
                <AccordionItem border="0" p="0" value={title}>
                    <AccordionItemTrigger
                        p="0"
                        _hover={{ backgroundColor: 'transparent' }}
                        _icon={{ color: arrowColor }}
                        indicatorPlacement="end"
                    >
                        <Text pl="8px" fontSize="14px" fontWeight="bold" lineHeight="20px" color={textColor} textTransform="uppercase">
                            {title}
                        </Text>

                        {/* <AccordionIcon color={arrowColor} ml="12px" /> */}
                    </AccordionItemTrigger>
                    <AccordionItemContent p="0" pl="36px">
                        {tasks.map((task, idx) => (
                            <TaskItem item={task} key={task.id} isLastItem={idx === Object.keys(tasks).length - 1} />
                        ))}
                    </AccordionItemContent>
                </AccordionItem>
            </AccordionRoot>
        </Box>
    )
}

export default Container
